<template>
<div class="quote-smt  mg-b-bs" :data-isparamsok="isQuoteParamsOk">
	<a v-if="isFromPcb" class="next-btn next-btn-default" style="margin-bottom:20px;" @click.stop="handleSmtToPcb">
		<i class="icon fs-sm mg-r-sm">
			&#xe67f;
		</i>
		Only PCB
	</a>
	<np-upload :opts="upCentroidFileopts" :uploadedFile="uploadedCentroidFile"  @clear="clearCentroidFiles" @success = "getCentroidFiles" class="quote-smt-upload">
		<p v-if="!centroidFile" class="file-type-tip pd-t-xs fs-sm fc-dis"> {{ LANG.zip_rar_50 }} </p>
	</np-upload>
	<!--rstfiles comfiles -->
	<div style="padding-top:20px;">
		PCBA Qty <i class="fc-main">* </i> 
		<np-input  width = "120px"   maxlength="20"  class="vlm" v-model="params.number"  @input="inputNumber"></np-input>
	</div>
	<np-upload 
		v-show="showStep == 1"		
		:data-number="pcscount" 
		:uploadedFile="uploadedBomFile"
		ref="upBomFile" 
		:opts="upBomFileopts" 
		@clear="clearBomFiles"
		@startUpload="hanldeStartUpload"
		@onprogress="hanldleOnProgress"
		@success = "getBomFiles"
		class="quote-smt-upload mg-t-bs"
	>
		<p class="file-type-tip pd-t-xs fs-sm mg-b-sm fc-dis" v-if="!bom_data.length"> {{ LANG.xls_xlsx_5 }} </p>
		<a href="/uploads/bom_template_nextpcb.xls" class="fc-blue">{{ LANG.download_bom }} <i class="fc-blue">{{ LANG.template }}</i></a>
	</np-upload>

	<div v-if="showStep == 2" id="bodyBomLoadingBox" class="analyzing-box-bom">
		<img id="bodyBomLoadingImg" :src="$imgList.loading_0" alt="">
		<p id="bodyBomLoadingTip" class="pd-t-xs fs-sm">{{analyzingTip}}</p>
	</div>

	<p class="pd-tb-bs fc-dis" v-if="!bom_data.length && !isBomContinue">
		{{ LANG.bom_file_template_tip }} :
	</p>
	<!-- <template v-else>
		<p class="pd-tb-bs" v-if="partsNumber" v-html="LANG.resoleLANG('bom_nochecked_number',{number:'<strong class=\'fc-err f-bold\'>'+partsNumber+'</strong>'})"></p>	
	</template> -->

	<template v-if="bomMatchData && !isBomContinue">
		<div ref="bomFixed" class="pd-tb-bs" :class="{'bom-tip-fixed':bomFixed && !isMinWidth && !isInDFM}" >
			<p>
				<span class="f-bold">{{ LANG.matched_parts }}： </span>
				<b class="f-bold" style="color:#05A841;">{{bomMatchData.confirm_total}}</b> / <b class="f-bold">{{bomMatchData.item_total}}</b>
			</p>
			<p v-if="notMatchNum" v-html="LANG.resoleLANG('bom_notmatch_tip',{number:'<strong class=\'fc-err f-bold\'>'+notMatchNum+'</strong>'})"></p> 
		</div>
	</template>
			
	<table v-if="!isBomContinue" class="quote-smt_table">
		<thead v-if="bom_data.length" :class="{'bom-table-fixed':bomFixed && !isMinWidth && !isInDFM}" :style="{top:notMatchNum?'247px':'209px'}">
			<tr>
				<th></th>
				<th>{{ LANG.designator }}</th>
				<th>{{ LANG.qty }}</th>
				<th>{{ LANG.manufacturer_part_number }}</th>
				<th>{{ LANG.unit_price1 }}</th>
				<th v-html="LANG.bom_match_lead_time"></th>
				<th>{{ LANG.customer_supply }}</th>
				<th>{{ LANG.plan_qty }}</th>
				<th>{{ LANG.waste_qty }}</th>
				<th>{{ LANG.total_qty }}</th>	
			</tr>
		</thead>
		<thead v-else>
			<tr>
				<th></th>
				<th>{{ LANG.designator }} <i class="fc-err">*</i></th>
				<th>{{ LANG.qty }} <i class="fc-err">*</i></th>
				<th style="min-width:110px;">{{ LANG.manufacturer_part_number }} <i class="fc-err">*</i></th>
				<th>{{ LANG.customer_supply }}</th>
				<th>{{ LANG.customer_remark }}</th>							
			</tr>
		</thead>
		<tbody v-if="bom_data.length">
			<tr v-for="(v,i) in bom_data" :key="i">				
				<td v-for="(m,n) in v" :key="n">
					<template v-if="n == 0">		
						<checkbox :disable="true"  :value="m.value"></checkbox>			
						<!-- <input disabled :checked="m.value" :type="m.type"> -->
					</template>
					<template v-else>
						<span v-show="![1,9].includes(n)" :class="{'fc-err':m.color=='red'}">
							{{m.value}}
						</span>
						<!-- 位号 -->
						<span v-show="n == 1" :class="{'fc-err':m.color=='red'}" @mouseover="alertDesignatorHelp($event,m.value)" @mouseleave="alertDesignatorHelp($event,m.value)" class="designator-text-ellipsis">
							{{m.value}}
						</span>
						<span v-show="n == 9" :class="{'fc-err':m.color=='red'}" @mouseover="alertTotalHelp($event,m)" @mouseleave="alertTotalHelp($event,m)" class="designator-text-ellipsis">
							{{m.value}}
						</span>
					</template>					
				</td>							
			</tr>			
		</tbody>
		<tbody v-else>
			<tr>
				<td>1</td>
				<td>C1,C2,C3,C4</td>
				<td>4</td>
				<td>MFR3WSFTE 73-2K</td>
				<td>--</td>
				<td>--</td>				
			</tr>
			<tr>
				<td>2</td>
				<td>D1,D2</td>
				<td>2</td>
				<td>1H104ZC4P-3F-ZNR</td>
				<td>--</td>
				<td>--</td>				
			</tr>
			<tr>
				<td>3</td>
				<td>B2-B9</td>
				<td>8</td>
				<td>CC 81-N5U2J1B220KSEW</td>
				<td>Y</td>
				<td>--</td>				
			</tr>
			<tr>
				<td>4</td>
				<td>A1</td>
				<td>1</td>
				<td>LD1117V33</td>
				<td>DNP</td>
				<td>--</td>				
			</tr>
		</tbody>
	</table>
	<template  v-if="!bom_data.length && !isBomContinue">
		<p class="fc-dis quote-smt-tips">{{ LANG.bom_tip1 }}</p>
		<p class="fc-dis quote-smt-tips">{{ LANG.bom_tip2 }}</p>
		<p class="fc-dis quote-smt-tips">{{ LANG.bom_tip3 }}</p>
		<p class="fc-dis quote-smt-tips">{{ LANG.bom_tip4 }}</p>
	</template>
	<div v-if="isBomContinue" class="not-match-bom">
		<div class="icon">
			<img :src="`${$imgList.not_match_all}`">
		</div>
		<p class="mg-t-md" v-html="LANG.bom_notmatch_all1"></p>
		<p class="mg-t-lg" v-html="LANG.resoleLANG('bom_notmatch_all2',{template:`<a href='/uploads/bom_template_nextpcb.xls' class='fc-blue'>BOM template</a>`})"></p>
	</div>
	<!-- 登錄彈出窗 -->
	<!-- <login-win v-model="loginWinShow" @loginsuccess = "loginsuccess"></login-win>	 -->
</div>
</template>

<script>
import input from '@/_module/input/index.vue'
import npUpload from '@/_module/upload/index.vue'
//import quotecheck from '@/_module/quotecheck/index.vue'
//import input from '@/_module/input/index.vue'
//import pubmixin from '@/mixins/quote/public_mixin.js'
//import smtcount from '@/mixins/quote/smt_count.js'
//import loginWin from '@/components/public/loginwin.vue'
import checkbox from '@/_module/checkbox/index.vue'
//import numberInput from '@/_module/numberInput/index.vue'

import lottie from 'lottie-web'
import animationLoading from '@/assets/animation/count-down.json'
let debounceObj = {};
export default {
	name:"quote_smt",
	data(){		
		return {
			params:{
				pcba_bom_id:0,
				buy_bom: "" ,// 'bom物料提供|1Turnkey|2Kitted or Consigned|3Combo',
				bom_number: "",
				custom_pcb_ban: '',// 'pcb提供|1客供|2nextpcb提供',
				// custom_pcb_ban2: '',//fpc，rfpc關聯時顯示
				number: 5 ,// 'pcb数量',
				pcb_height:'' ,// 'pcb单片尺寸（长）',
				pcb_width:'' ,// 'pcb单片尺寸（宽）',
				single_or_double_technique:'' ,// '单双面|1单面|2双面',
				patch_material_type : '',// '贴片物料种类',
				patch_pad_number:'' ,// '贴片焊盘数量',
				is_plug : '',// '焊接插件料',
				plug_material_type: '', // '插件物料种类',
				plug_number:'' ,// '插件焊盘数量',
				need_split:'' ,// '需要拆板',
				need_conformal_coating:'' ,// '刷三防漆',
				x_ray_number:'' ,// 'X-RAY元件数量',
				x_ray_unit_number: '',// 'X-RAY单板数量',
				is_test : '',// '功能测试',
				//activity_code:'',
				smt_part_no:"",
				smt_po_number:'',
				smt_note:'',
				pcb_order_id: '',
				pcb_order_sn: '',
				bom_order_id: '',
				bom_order_sn: ''
			},	
			bom_data:[],
			pcba_bom_id:0,	
			upCentroidFileopts:{
				btntext:"Centroid File",
				upfile: this.$api.upfile,
				accept:".zip,.rar",		
				params:{
					type:"attach"
				},	
				maxSizeTip:(size)=>{
					this.$alert.toast(this.LANG.resoleLANG('check_file_size',{size}),{type:"error"})
				}	,
				formatErrorTip:()=>{
					this.$alert.toast(this.LANG.check_file_format,{type:"error"})
				},
				maxsize:50
			},
			upBomFileopts:{
				btntext:"BOM File",
				upfile: this.$api.bombomMatch,
				accept:".xlsx,.xls,.csv",				
				params:{
					bom_number:5,
					type: "pcbabomfile"
				},
				maxSizeTip:(size)=>{
					this.$alert.toast(this.LANG.resoleLANG('check_file_size',{size}),{type:"error"})
				}	,
				formatErrorTip:()=>{
					this.$alert.confirm({
						title:" ",
						area:["480px","250px"],
						skin:"bompcbawin",
						content:`
							<svg style="float:left;padding-top: 2px;"  width="16" height="14" viewBox="0 0 16 14"><defs><style>.a{fill:#ffd306;}.b{fill:#ef3d1f;}</style></defs><g transform="translate(-686 -667)"><path class="a" d="M7.132,1.519a1,1,0,0,1,1.736,0L15.145,12.5a1,1,0,0,1-.868,1.5H1.723a1,1,0,0,1-.868-1.5Z" transform="translate(686 667)"/><path class="b" d="M0,7.1V6.5a.5.5,0,0,1,1,0v.6a.5.5,0,0,1-1,0ZM0,4.5V.5a.5.5,0,1,1,1,0v4a.5.5,0,1,1-1,0Z" transform="translate(693.502 671.286)"/></g></svg>
							<div class="pd-l-sm" style="overflow:hidden;"> 
								<h3 class="f-bold fs-bs"> ${this.LANG.bom_format_err} </h3>
								<p class="pd-t-sm file-parsing-failed-tip"> ${this.LANG.bom_format_err_tip}</p>
							</div>	
						`,
						btns:[{
							text:"Confirm",
							callBack(e){
								e.close()
							}
						}]
					})
				},
				maxsize:5
			},
			centroidFile:null,
			loginWinShow: false	,
			associatedVisible: false,
			uploadedCentroidFile: {},
			uploadedBomFile: {},
			bomFixed: false,
			bomMatchData: null,
			isBomContinue: false,
			showStep:1,
			analyzingTip: 'Matching Parts..',
			bomShowTimer:null,
			bomTipTimer:null,
			cancelTokenSource: null,
			bomCheckDialog: null,
			bomLoadingDialog: null,
			bomLoadingTimer: null,
			requestErrDialog: null
		}
	},
	mounted(){
		//测试
		this.$store.commit("setQuoteRelation","pcb");
		this.seturlDefault()
		window.addEventListener('scroll',this.handleScroll)
		this.$nextTick(()=>{
			console.log('in smt set pcba number--**--**')
			if(this.smt_params.number){
				this.params.number = this.smt_params.number
			}
		})
	},
	beforeDestroy(){
		window.removeEventListener('scroll',this.handleScroll)
	},
	computed:{	
		bcount(){
			return this.pcbparams.bcount;
		},	
		pcscount(){
			return this.pcbparams.pcscount;
		},
		pcbparams(){
			return this.$store.getters.getQuotepcb_params;
		},
		partsNumber(){
			let number = 0;
			let partsNumber = number;
			if(this.bom_data.length){
				let len = this.bom_data.length;		
				this.bom_data.forEach(v => {
					if(v && v[0] && v[0].value){
						number++;
					}
				});
				partsNumber = len - number;
			}
			this.$bus.$emit('bomManualQuoteNumberEvent', partsNumber)
			return partsNumber;
		},
		smt_params(){
			return this.$store.state.quote.smt_params;
		},
		aside_param(){
			return this.$store.state.quote.aside_param;
		},
		isQuoteParamsOk(){
			let pcbParamsOk = this.$store.getters.isQuoteParamsOk("pcb");
			let smtParamsOk = false;
			if(this.aside_param.gerber_file_id && this.aside_param.other_file_id && this.smt_params.bom_file_id){
					this.$store.commit("setQuoteStatus",{key:'smt',value:true});
					smtParamsOk = true;
			}else{
				this.$store.commit("setQuoteStatus",{key:'smt',value:false});
			}
			if(pcbParamsOk && smtParamsOk) return true;
			return  false;
		},
		isStepClick(){
			return this.$store.getters.getIsStepClick
		},
		notMatchNum(){
			if(!this.bomMatchData && !this.bomMatchData.item_total){
				return 0
			}
			return Number(this.bomMatchData.item_total) - Number(this.bomMatchData.confirm_total)
		},
		isMinWidth(){
			return this.$store.state.isMinWidth
		},
		isFromPcb(){
			return this.$store.state.isFromPcb
		},
		isInDFM(){
			if(window.isInDFM){
				return JSON.parse(window.isInDFM)
			}
			else{
				return false
			}
		},
		onlyCalcPCB(){
			return this.$store.state.quote.canQuote.pcb
		}
	},
	methods:{
		// 位号提示
		alertDesignatorHelp(e,value,width){
			width = width || '230px';
			this.$alert.dialog({
				content: value ,
				style: "max-width:"+width+";"
			},e)
		},
			// 总数量提示
		alertTotalHelp(e,row, width){
			if(!row.color && row.color !='red'){
				return false
			}
			width = width || '430px';
			this.$alert.dialog({
				content: 'If there is not enough MOQ, buy according to MOQ.' ,
				style: "max-width:"+width+";"
			},e)
		},
		async seturlDefault(){
			//先从第一个？截取后面的参数，再从#截取获取前面一段参数
			try{
				var temp = window.location.href.split('?')[1] || '';
				var temp2 = temp.split('#')[0] || '';
				var pram2 = new URLSearchParams(temp2);

				// 贴片文件
				this.uploadedCentroidFile = {
					status: true,
					fid: pram2.get('other_file_id'),
					NP_FILE_ID: pram2.get('other_file_id'),
					url: pram2.get('other_file'),
					name: pram2.get('other_file').substring(pram2.get('other_file').lastIndexOf('/')+1)
				} 
				this.getCentroidFiles({
					res: this.uploadedCentroidFile
				})
				// bom文件
				this.uploadedBomFile = {
					status: true,
					fid: pram2.get('bom_file_id'),
					NP_FILE_ID: pram2.get('bom_file_id'),
					url: pram2.get('bom_file'),
					name: pram2.get('bom_file').substring(pram2.get('bom_file').lastIndexOf('/')+1)
				}
				this.pcba_bom_id = pram2.get('pcba_bom_id')
				const bom_file_id = pram2.get('bom_file_id')

				this.$store.commit("setQuoteParams",{value:this.pcba_bom_id,key:"smt_params.pcba_bom_id"});
				const res = await this.$http.post(this.$api.bombomMatch, {pcba_bom_id: this.pcba_bom_id,bom_file_id});
				this.handleBomMatch(res, pram2.get('bom_file_id'))
				// 链接其他参数
				for(let item of pram2){
					if(item[0] === 'material_type'){
						this.params.patch_material_type = item[1]
					}else{
						this.params[item[0]] = item[1];
					}
					console.log(276, item[0], item[1])
				}
				console.log(279, pram2, temp2, pram2['other_file_id'])
			}catch(e){
				//TODO handle the exception
			}
		},
		debounce: function(fn,key,times){
			var wait = times || 500;
			if(typeof key === "number"){
				wait = key;
				key = "clearTime";
			}
			//防抖函数			
			if(debounceObj[key]){				
				debounceObj[key] = clearTimeout(debounceObj[key]);				
			}		
			debounceObj[key] = setTimeout(fn,wait);
		},
		inputNumber(number){		
			if(number) number = String(number).replace(/[^0-9.]/g,"");
			if(number){				
				let arr = number.split(".");
				if(arr.length >= 2){
					if(arr[1].length>1) arr[1] = arr[1].substr(0,1);
					number = arr[0] + "." + arr[1];
				}													
			}
			this.params.number =  number;
			console.log('inputNumber',number)
			let _this = this;			
			this.$tools.debounce(()=>{						
				if(Number(number)<5){
					_this.params.number = 5;
				}	
				if(_this.bcount && _this.pcscount){
					if(Number(number)>_this.pcscount){
						_this.$alert.msg(this.LANG.exceed_the_qty_of_pcb)
						_this.params.number = _this.pcscount;
					}
				}		
			},"number_smt2",800)();
			
			this.$store.commit("setIsStepClick", false)
		},
		clearCentroidFiles(e){
			if(e){	
				this.centroidFile = null;			
				this.$store.commit("setQuoteParams",{value:"",key:"aside_param.other_file_id"});
				this.$store.commit("setQuoteParams",{value:"",key:"aside_param.other_file"});
			}
		},
		getCentroidFiles(rst){			
			let fileData = rst.res;			
			if(fileData.status){
				this.centroidFile = fileData;				
				this.$store.commit("setQuoteParams",{value:fileData.fid,key:"aside_param.other_file_id"});
				this.$store.commit("setQuoteParams",{value:fileData.url,key:"aside_param.other_file"});
			}
			else{
				// 谷歌ga4事件跟踪
				try {
					window.dataLayer.push({event:'pcbacentroidfailed'})
				} catch (error) {
					console.error(error)
				}
			}
		},
		clearBomFiles(e){
			if(e){
				this.bom_data = [];
				this.bomMatchData = null
				this.isBomContinue = false
				this.pcba_bom_id = 0;
				this.analyzingTip = 'Matching Parts..'
				this.showStep = 1
				clearTimeout(this.bomTipTimer)
				this.bomTipTimer = null
				this.$store.commit("setQuoteParams",{value:"",key:"smt_params.pcba_bom_id"});
				this.$store.commit("setQuoteParams",{value:"",key:"smt_params.bom_file_id"});
				this.$store.commit("setQuoteParams",{value:"",key:"smt_params.bom_file"});
			}
		},
		getBomFiles(rst){//rst		
			//console.log(rst)
			let res = rst.res;
			console.log(rst)
			if(typeof rst.bc === "function") rst.bc(true);
			this.handleBomMatch(res)
		},
		handleBomMatch(res, urlFileId) {
			/* 
			410001   格式不正确的
			410008  表格是空的
			410009  表头型号列没有
			410010  表头单机用量列没有
			410011  表头位号没有
			410005  位数&数量不匹配
			*/		
			const that=this
			clearTimeout(this.bomShowTimer)
			clearTimeout(this.bomTipTimer)
			this.bomTipTimer = null
			this.analyzingTip = 'Matching Parts..'
			this.showStep = 1
			console.log('handleBomMatch',this.bomShowTimer,this.bomTipTimer,this.showStep)
			if(res.code == 200){
				this.bomMatchData = res.data
				let fileData = res.data;
				this.bom_data = fileData.bom_data;
				this.pcba_bom_id = fileData.pcba_bom_id;
				//提交文件参数				
				this.$store.commit("setQuoteParams",{value:fileData.pcba_bom_id,key:"smt_params.pcba_bom_id"});
				this.$store.commit("setQuoteParams",{value:fileData.fid || urlFileId,key:"smt_params.bom_file_id"});
				this.$store.commit("setQuoteParams",{value:fileData.url,key:"smt_params.bom_file"});
				if(fileData.is_all_customer){
					let html =`<h3 class="fs-bs f-bold">${this.LANG.warning}</h3>
					<p style="padding-top:16px;">${this.LANG.customers_supply_tip1}</p>
					<div class="icon-list">
						<div class="icon-item">
							<img src="${window.IMGURL}/bom-icon1.png">
							<p>${this.LANG.cust_supply_text1_1}</p>
							<p class="fc-main">${this.LANG.cust_supply_text1}</p>
						</div>
						<div class="icon-item">
							<img src="${window.IMGURL}/bom-icon2.png">
							<p class="fc-main">${this.LANG.cust_supply_text2}</p>
						</div>
						<div class="icon-item">
							<img src="${window.IMGURL}/bom-icon3.png">
							<p class="fc-main">${this.LANG.cust_supply_text3}</p>
						</div>
						
					</div>
					<p>${this.LANG.resoleLANG('customers_supply_tip2',{hqonline: `<a class="fc-blue" href="${this.$tools.getHqonlineUrl()}" target="_blank" style="text-decoration: underline;">HQonline.com</a>`})}</p>	
					`
					this.$alert.confirm({
						title:" ",
						area:["480px"],
						content:`
							<svg style="float:left;padding-top: 4px;"  width="16" height="14" viewBox="0 0 16 14"><defs><style>.a{fill:#ffd306;}.b{fill:#ef3d1f;}</style></defs><g transform="translate(-686 -667)"><path class="a" d="M7.132,1.519a1,1,0,0,1,1.736,0L15.145,12.5a1,1,0,0,1-.868,1.5H1.723a1,1,0,0,1-.868-1.5Z" transform="translate(686 667)"/><path class="b" d="M0,7.1V6.5a.5.5,0,0,1,1,0v.6a.5.5,0,0,1-1,0ZM0,4.5V.5a.5.5,0,1,1,1,0v4a.5.5,0,1,1-1,0Z" transform="translate(693.502 671.286)"/></g></svg>
							<div style="overflow:hidden;padding-left:10px;"> 
								${html}
							</div>
						`,
						// skin:"bompcbawin",
						btns:[{
							text: this.LANG.go_to_hq,
							callBack: (e)=>{
								window.open(this.$tools.getHqonlineUrl())
								// e.close()
							}
						},
						{
							text: this.LANG.got_it,
							callBack: (e)=>{
								e.close()
							}
						}],
						btnAlign:'right'
						// closeBtn: false
					})
				}
				
			}else{
				// 谷歌ga4事件跟踪
				try {
					window.dataLayer.push({event:'bomfilefailed'})
				} catch (error) {
					console.error(error)
				}
				if(res.code == 440044){ // 格式不对
					
					const btnList=[
						{
							text: this.LANG.bom_reupload,
							callBack(e){
								that.$refs.upBomFile.clearFile("all");
								e.close()
							}
						}
					]
					if(res.can_continue){
						btnList.push({
							text: this.LANG.continue,
							callBack(e){
								that.handleBomMatchAfterAction({is_continue:1,fid:res.fid},(res1)=>{
									that.isBomContinue = true
									that.handleBomMatch(res1)
									e.close()
								})
								
							}
						})
					}
					this.$alert.confirm({
						title:" ",
						area:["480px","280px"],
						content:`
							<svg style="float:left;padding-top: 2px;"  width="16" height="14" viewBox="0 0 16 14"><defs><style>.a{fill:#ffd306;}.b{fill:#ef3d1f;}</style></defs><g transform="translate(-686 -667)"><path class="a" d="M7.132,1.519a1,1,0,0,1,1.736,0L15.145,12.5a1,1,0,0,1-.868,1.5H1.723a1,1,0,0,1-.868-1.5Z" transform="translate(686 667)"/><path class="b" d="M0,7.1V6.5a.5.5,0,0,1,1,0v.6a.5.5,0,0,1-1,0ZM0,4.5V.5a.5.5,0,1,1,1,0v4a.5.5,0,1,1-1,0Z" transform="translate(693.502 671.286)"/></g></svg>
							<div class="pd-l-sm" style="overflow:hidden;"> 
								<h3 class="f-bold fs-bs"> ${res.msg}<br/>${this.LANG.reupload_bom}</h3>
								<p class="pd-t-bs">${this.LANG.refer_bom_template}</p>	
								<p class="pd-t-sm">${this.LANG.bom_continue_tip}</p>	
							</div>
						`,
						skin:"bompcbawin",
						btns:btnList,
						closeBtn: false,
						btnAlign:'right'
					})
				}else if(res.code == 440055){ // 位号/数量不匹配
					let btn1Click=false,btn2Click=false
					let bodyStr=``
					res.mismatch.slice(0,5).map(item => {
						bodyStr+=`<tr>
						<td>${item.line_num}</td>
						<td class="designator-text-ellipsis">${item.location}</td>
						<td class="fc-green">${item.correct_qty}</td>
						<td class="fc-main">${item.doc_qty}</td>
						</tr>
						`
					})
					let tableStr=`<table class='bom-check-table'>
						<thead>
							<tr>
								<th>${this.LANG.bom_thead_line}</th>
								<th>${this.LANG.bom_thead_designators}</th>
								<th>${this.LANG.correct_qty}</th>
								<th>${this.LANG.doc_qty}</th>
							</tr>
						</thead>
						<tbody>
							${bodyStr}
						</tbody>
					</table>`
					// if(res.mismatch_total > 6) {
					// 	tableStr += `<p class="pd-t-bs">${this.LANG.download_and_see_more}</p>	`
					// }
					let btnClass=''
					if(res.show_missmatch_op==0){
						btnClass='hide-btn'
					}
					this.bomCheckDialog = this.$alert.confirm({
						title:`<svg class="pd-r-sm" style="padding-top: 2px;"  width="16" height="14" viewBox="0 0 16 14"><defs><style>.a{fill:#ffd306;}.b{fill:#ef3d1f;}</style></defs><g transform="translate(-686 -667)"><path class="a" d="M7.132,1.519a1,1,0,0,1,1.736,0L15.145,12.5a1,1,0,0,1-.868,1.5H1.723a1,1,0,0,1-.868-1.5Z" transform="translate(686 667)"/><path class="b" d="M0,7.1V6.5a.5.5,0,0,1,1,0v.6a.5.5,0,0,1-1,0ZM0,4.5V.5a.5.5,0,1,1,1,0v4a.5.5,0,1,1-1,0Z" transform="translate(693.502 671.286)"/></g></svg><b style="font-weight:700;">${this.LANG.designator_quantity_mismatch}</b>`,
						area:["780px"],
						skin:"bompcbawin1 bomcheck",
						content:`
							<div style="overflow:hidden;"> 
								<p>${this.LANG.bom_check_confirm_tip}</p>
								<p class="pd-t-sm pd-b-sm">${this.LANG.resoleLANG('total_line_mismatch',{number: `<strong class="fc-main f-bold">${res.mismatch_total}</strong>`})}</p>	
								${tableStr}
							</div>	
						`,
						btns: [
							{
								text: this.LANG.bom_check_btn2,
								skin:`bom-check-btn ${btnClass}`,
								callBack: (e)=>{
									// 以单机用量为准；位号信息保持不变
									if(btn2Click || btn1Click){
										return false
									}
									btn2Click = true
									document.getElementsByClassName('np-alert-btns_btn0')[0].className += ' btn-not-allow'
									that.handleBomMatchAfterAction({missmath_type:2,fid:res.fid},(res1)=>{
										that.handleBomMatch(res1)
										e.close()
									})
								}
							},
							{
								text: this.LANG.bom_check_btn1,
								skin:`bom-check-btn ${btnClass}`,
								callBack: (e)=>{
									// 以位号为准；单机用量，按位号信息修正，提取至后台
									console.log(btn1Click)
									if(btn1Click || btn2Click){
										return false
									}
									btn1Click = true
									document.getElementsByClassName('np-alert-btns_btn1')[0].className += ' btn-not-allow'
									that.handleBomMatchAfterAction({missmath_type:1,fid:res.fid},(res1)=>{
										that.handleBomMatch(res1)
										e.close()
									})
								}
							},
							{
								text: this.LANG.download_error_correction_files,
								skin:'bom-check-btn',
								callBack: (e)=>{
									// 下载纠错文件
									this.downloadMismatchFile(res)
									that.$refs.upBomFile.clearFile("all");
									e.close()
								}
						}],
						closeBtn:(e)=>{
							// this.cancelRequest()
							// that.$refs.upBomFile.clearFile("all");
							this.handleBomCheckOnClose()
							e.close()
						}
					})
				}
				else if(res.code == 440056){ // bom匹配/报价超过1min,按999处理
					this.isBomContinue = true
					// this.bomMatchData = res.data
					let fileData = res.data;
					this.pcba_bom_id = fileData.pcba_bom_id;
					console.log(440056,this.isBomContinue)
					//提交文件参数				
					this.$store.commit("setQuoteParams",{value:fileData.pcba_bom_id,key:"smt_params.pcba_bom_id"});
					this.$store.commit("setQuoteParams",{value:fileData.fid || urlFileId,key:"smt_params.bom_file_id"});
					this.$store.commit("setQuoteParams",{value:fileData.url,key:"smt_params.bom_file"});
				}
				else{
					this.$alert.confirm({
						title:" ",
						area:["480px"],
						content:`
							<svg style="float:left;padding-top: 2px;"  width="16" height="14" viewBox="0 0 16 14"><defs><style>.a{fill:#ffd306;}.b{fill:#ef3d1f;}</style></defs><g transform="translate(-686 -667)"><path class="a" d="M7.132,1.519a1,1,0,0,1,1.736,0L15.145,12.5a1,1,0,0,1-.868,1.5H1.723a1,1,0,0,1-.868-1.5Z" transform="translate(686 667)"/><path class="b" d="M0,7.1V6.5a.5.5,0,0,1,1,0v.6a.5.5,0,0,1-1,0ZM0,4.5V.5a.5.5,0,1,1,1,0v4a.5.5,0,1,1-1,0Z" transform="translate(693.502 671.286)"/></g></svg>
							<div class="pd-l-sm" style="overflow:hidden;"> 
								<h3 class="f-bold fs-bs"> ${this.LANG.bom_not_valid_data}</h3>
								<p class="pd-t-bs">${this.LANG.refer_bom_template}</p>	
								<p class="pd-t-sm">${this.LANG.team_one_to_one_assistance}</p>	
							</div>
						`,
						btns:[{
							text: this.LANG.get_assistance,
							href: 'mailto:support@nextpcb.com'
						},{
							text: this.LANG.ok,
							callBack(e){
								e.close()
							}
						}],
						btnAlign:'right'
					})
				}
				if(![440044, 440055, 440056].includes(res.code)){
					console.log('clear bom***')
					this.$refs.upBomFile.clearFile("all");
					this.$store.commit("setQuoteParams",{value:"",key:"smt_params.pcba_bom_id"});
					this.$store.commit("setQuoteParams",{value:"",key:"smt_params.bom_file_id"});
					this.$store.commit("setQuoteParams",{value:"",key:"smt_params.bom_file"});
				}
				
			}
		},
		// 下载纠错文件
		downloadMismatchFile (res) {
			this.$http.get(this.$api.bomDownMismatch, {
				params: {
					fid: res.fid
				}
			}).then((mismatchRes)=>{
				if(mismatchRes.status == 1){
					const mismatchADom = document.createElement("a")
					mismatchADom.style.display = 'none'
					mismatchADom.setAttribute('target', '_blank')
					// mismatchADom.setAttribute('download', 'download')
					mismatchADom.href = mismatchRes.data.file_url
					document.body.appendChild(mismatchADom)
					mismatchADom.click()
					document.body.removeChild(mismatchADom)
				} else {
					this.$alert.msg(mismatchRes.msg)
				}
			})
		},
		handleBomMatchAfterAction(sendData,callBack){
			const CancelToken = this.$http.CancelToken;
    	this.cancelTokenSource = CancelToken.source()
			if(sendData.missmath_type){
				this.handleBomLoading()
			}
			this.$http.post(this.$api.bombomMatch,{...sendData,bom_number: this.params.number},{ cancelToken: this.cancelTokenSource.token }).then(res=>{
				callBack(res)
				if(this.bomLoadingDialog){
					this.bomLoadingDialog.close()
					this.bomLoadingDialog = null
				}
				if(this.bomLoadingTimer){
					clearTimeout(this.bomLoadingTimer)
					this.analyzingTip = 'Matching Parts..'
					this.bomLoadingTimer = null
				}
			}).catch(e=>{
				console.log('e',e,typeof e,e.toString())
				if(!e.toString().includes('user cancel')){
					console.log('not is user cancel')
					if(this.bomLoadingDialog){
						this.bomLoadingDialog.close()
						this.bomLoadingDialog = null
					}
					if(this.bomCheckDialog){
						this.bomCheckDialog.close()
						this.bomCheckDialog = null
					}
					if(this.bomLoadingTimer){
						clearTimeout(this.bomLoadingTimer)
						this.analyzingTip = 'Matching Parts..'
						this.bomLoadingTimer = null
					}
					this.handleRequestError()
					this.$refs.upBomFile.clearFile("all");
				}
			})
		},
		cancelRequest(){
			if(this.cancelTokenSource){
				this.cancelTokenSource.cancel('user cancel')
				this.cancelTokenSource = null
			}
		},
		handleBomCheckOnClose(){
			console.log('handleBomCheckOnClose')
			this.cancelRequest()
			this.$refs.upBomFile.clearFile("all");
		},
		handleBomLoading(){
			document.getElementsByClassName('bomcheck')[0].children[0].style.display='none'
			let html = `
			<div id="bomLoadingBox" class="analyzing-box-bom" style="background:#FFF;">
				<img id="bomLoadingImg" src="${this.$imgList.loading_0}">
				<p id='bomLoadingTip' class="pd-t-xs fs-sm">${this.analyzingTip}</p>
			</div>
			`
			this.bomLoadingTimer = setTimeout(()=>{
				this.analyzingTip = 'Please wait a moment. Larger BOM files may take longer to analyze.'
				document.getElementById("bomLoadingTip").innerHTML='Please wait a moment. Larger BOM files may take longer to analyze.'
				console.log('this.bomLoadingTimer 5s later',this.bomLoadingTimer,this.analyzingTip)
				this.$forceUpdate()
			}, 5 * 1000)

			this.bomMatchAnimation(2)

			console.log('this.bomLoadingTimer',this.bomLoadingTimer,this.analyzingTip)

			this.bomLoadingDialog = this.$alert.confirm({
				title:false,
				area:["780px"],
				skin:"bompcbawin1",
				content:html,
				btns: [],
				closeBtn:(e)=>{
					this.handleBomCheckOnClose()
					this.bomCheckDialog.close()
					this.bomCheckDialog = null
					if(this.bomLoadingTimer){
						clearTimeout(this.bomLoadingTimer)
						this.analyzingTip = 'Matching Parts..'
						this.bomLoadingTimer = null
					}
					e.close()
				}
			})
		},
		handleRequestError(){
			let html = `
			<div class="analyzing-box-bom">
				<i class="icon" style="color:#e6a23c;font-size: 48px;">&#xe60f;</i>
				<p class="pd-t-md fs-md">Quote timed out, please try again</p>
			</div>
			`
			setTimeout(()=>{
				this.requestErrDialog.close()
				this.requestErrDialog = null
			}, 3 * 1000)

			console.log('this.bomLoadingTimer',this.bomLoadingTimer,this.analyzingTip)

			this.requestErrDialog = this.$alert.confirm({
				title:false,
				area:["780px"],
				skin:"bompcbawin1",
				content:html,
				btns: [],
				closeBtn:false
			})
		},
		countCalc(){
			//計價方法
			const isRuning= this.$store.getters.isValuationing				
			if(this.isQuoteParamsOk && !isRuning){
				this.$tools.debounce(()=>{
					const promise = this.$store.dispatch("calcQuoteValuation");  
					console.log('promist',promise)
					if(promise){
							promise.then((res)=>{			
								console.log(res.code==200,this.isStepClick,!this.isStepClick)
								if(res.code == 200 && !this.isStepClick){
										this.$store.dispatch('getStepPrice')
								}							
							})
						}					
				},"countCalc",1050)();           
			}
		},
		getbom_data(v,bc){
			if(v && this.pcba_bom_id){
				try {
					this.$tools.debounce(()=>{
						return this.$http.post(this.$api.bomNeedQuotation,{bom_number:v,pcba_bom_id:this.pcba_bom_id}).then((res)=>{										
							if(res.code == 200){
								if(typeof bc === "function"){
									bc(res)
								}
								if(res.data.bom_data) this.bom_data = res.data.bom_data;
							}else{
								this.$alert.msg(res.msg);
							}
						});						
					},"getbom_data",600)();  
					
				} catch (e) {
					console.log(e)
				}
			}			
		},
		handleScroll(){
			
			if(!this.$refs.bomFixed){
				return false
			}
			let scrolltop = document.documentElement.scrollTop || document.body.scrollTop	
			let offsetTop = this.$refs.bomFixed.offsetTop;
			if(scrolltop > offsetTop){
				this.bomFixed = true;
			}else{
				this.bomFixed = false;
			}
		},
		hanldeStartUpload(){
			
		},
		hanldleOnProgress(val){
			console.log('hanldleOnProgress',val)
			if(!this.bomTipTimer){
				clearTimeout(this.bomTipTimer)
				this.bomTipTimer = setTimeout(()=>{
					this.analyzingTip = 'Please wait a moment. Larger BOM files may take longer to analyze.'
				},1000*5)
				console.log('start upload',this.bomTipTimer)

				this.bomMatchAnimation(1)
			}
			
			if(val.process == 100){
				this.showStep = 1
				this.analyzingTip='Matching Parts..'
				clearTimeout(this.bomTipTimer)
				this.bomTipTimer = null
				lottie.destroy()
				const aniDom = document.getElementById('animationCountRef')
				if(aniDom){
					aniDom.remove()
				}

				console.log('hanldleOnProgress end',this.showStep,this.bomTipTimer)
				return false
			}
			this.showStep = 2
		},
		handleSmtToPcb(){
			this.$store.commit("setQuoteValuation", null)
			this.$store.commit("setChangeType", true)
			this.$store.commit("setQuoteRelation","");
			this.$store.commit("setIsStepClick", false)
			const newUrl = location.href.split('#')[0].replace('pcb-assembly-quote','pcb-quote')
			history.replaceState(null, '', newUrl)
			window.sessionStorage.setItem('pcbParams',JSON.stringify(this.pcbParams))
			this.$router.replace('/pcb-quote')
		},
		// 初始化的动画
    initAnimation() {
      this.$nextTick(() => {
				console.log('initAnimation****')
        lottie.loadAnimation({
          container: document.getElementById('animationCountRef'),
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: animationLoading
        })
      })
    },
		// bom报价30秒后动画 type 1-页面 2-弹窗
		bomMatchAnimation(type){
			const domMap = {
				1:{
					box:'bodyBomLoadingBox',
					img:'bodyBomLoadingImg',
					tip:'bodyBomLoadingTip'
				},
				2:{
					box:'bomLoadingBox',
					img:'bomLoadingImg',
					tip:'bomLoadingTip'
				}
			}
			const countDownTimer = setTimeout(()=>{
				console.log('32s later')
				try {
					if(document.getElementById(domMap[type].img)) {
						document.getElementById(domMap[type].img).style.display="none"
					}
					const countDownDom = document.createElement('div')
					countDownDom.id = 'animationCountRef'
					countDownDom.className = 'count-loading'
					const parentDom = document.getElementById(domMap[type].box)
					if(parentDom){
						parentDom.insertBefore(countDownDom,document.getElementById(domMap[type].tip))
					}
					const countNumDom = document.createElement('count-down')
					countNumDom.className = 'count-num'
					document.getElementById('animationCountRef').append(countNumDom)
					this.initAnimation()
				} catch (error) {
					console.error('countDownTimer error',error)
				}
				
			}, 1000 * 32)

		},
		calcPCB(){
			this.$tools.debounce(()=>{
				const promise = this.$store.dispatch("calcPCBValuation");  
				console.log('onlyCalcPCB',promise)	
			},"countCalcPCB",1050)()
		}
	},
	watch:{
		"aside_param.gerber_file_id":function(v){			
			if(v) this.countCalc();
		},
		"aside_param.other_file_id":function(v){
			if(v) this.countCalc();
		},
		"smt_params.bom_file_id":function(v){
			if(v) this.countCalc();
		},
		"params.number":function(v){
			this.upBomFileopts.params.bom_number = (v>=5?v:5);			
			this.$store.commit("setQuoteParams",{value:v,key:"smt_params.number"});
			this.$store.commit("setQuoteParams",{value:v,key:"smt_params.bom_number"});
			// this.$store.commit("setQuoteParams",{value: 1,key:"pcb_params.show_step"});	
			let _this = this;			
			this.debounce(()=>{
				console.log('in params.number----------')
				_this.getbom_data(v,function(){
					if(v) _this.countCalc();
				});
				if(this.onlyCalcPCB && !this.isQuoteParamsOk){
					this.calcPCB()
				}
			},"number_smt",500);						
		},
		pcscount(v){
			this.upBomFileopts.params.bom_number = (v>=5?v:5);
			this.debounce(()=>{
				console.log('in pcscount----------',v)
				this.getbom_data(v,()=>{
					this.countCalc()
				});		
			},"pcscount",500);
			this.$store.commit("setQuoteParams",{value:v,key:"smt_params.bom_number"});
			this.$store.commit("setQuoteParams",{value:v,key:"smt_params.number"});
			this.params.number = (v>=5?v:5);
		},
		onlyCalcPCB(v){
			console.log('pcb can calc',v)
			if(v){
				this.calcPCB()
			}
		}
	},
	components: {
		//'quote-check':quotecheck,
		'np-input':input,	
		"np-upload":npUpload,	
		//"login-win": loginWin,
		//"number-input": numberInput
		//checkbox
		"checkbox":checkbox
	}
}
</script>

<style lang="scss">
.np-alert-btns{
	padding-bottom: 20px;
}
.bompcbawin,.bompcbawin1 {
	.np-alert-title {
		background: #f3f3f3;				
	}
	.np-alert-close {
		color:#333;
	}
	.np-alert-btns {
		text-align: center;
	}
	.np-alert-btns_btn0 {
		background: #c00;
		color:#fff;
		border-color: #c00;
	}
	.np-alert-btns_btn1 {
		background: #fff;
		color:#333;
		border-color: #D2D2D2;
	}
	.file-parsing-failed-tip {
    padding-top: 20px;
    line-height: 22px;
	}
	.designator-quantity-line {
		line-height: 22px;
		span {
			display: inline-block;
			&:nth-child(1) {
				width: 80px;
			}
			&:nth-child(2) {
				width: 220px;
			}
		}
	}
}

.bompcbawin1{
	.np-alert-btns_btn0,.np-alert-btns_btn1 {
		background: #fff;
		color:#333;
		border-color: #D2D2D2;
	}
}
.quote-smt {
	background: #fff;
	padding: 20px 20px 60px;
	&-upload {
		text-align: center;
		background: #f8f8f8;
		padding: 20px;
		.np-btn {
			cursor: pointer;
			display: inline-block;
			width: 273px;
			height: 38px;
			line-height: 38px;
			background: #fff5f5;
			color: #CC0000;
			border: 1px solid #CC0000;
			text-align: center;
			border-radius: 2px;
			position: relative;
			z-index: 9;
			text-decoration: none;
		}
		.np-upload-preview {
			width: 50%;
		}
		.np-btn-hollow-dis {
			background-color: #ccc;
			color: #fff;
			border-color: #ccc;
			cursor: no-drop;
		}		
	}
	&_table {
		width: 100%;
		border: 1px solid #e6e6e6;	
		margin-bottom: 20px;
		word-break: break-word;
		td,th {
			padding: 6px;
			border-left: 1px solid #e6e6e6;
			border-bottom: 1px solid #e6e6e6;
			text-align: center;
		}
		th {
			background-color: #f9f9f9;
			line-height: 1;
			padding-top: 6px;
			padding-bottom: 6px;
			height: 32px;
		}
		.designator-text-ellipsis {
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		tr{
			td,th{
				&:nth-child(1){
					width: 30px;
    			min-width: 30px;
				}
				&:nth-child(2){
					width: 80px;
					min-width: 80px;
				}
				&:nth-child(3){
					width: 50px;
					min-width: 50px;
				}
				&:nth-child(4){
					width: 106px;
					min-width: 106px;
				}
				&:nth-child(5){
					width: 66px;
					min-width: 66px;
				}
				&:nth-child(6){
					width: 90px;
					min-width: 90px;
				}
				&:nth-child(7){
					width: 74px;
					min-width: 74px;
				}
				&:nth-child(8){
					width: 50px;
					min-width: 50px;
				}
				&:nth-child(9){
					width: 55px;
					min-width: 55px;
				}
				&:nth-child(10){
					width: 50px;
					min-width: 50px;
				}
				
			}
		}
	}
	&-tips {
		&::before{
			content: "";
			display: inline-block;
			width: 4px;
			height: 4px;
			border-radius: 50%;
			background-color: #999;
			margin-right: 8px;
			vertical-align: middle;
		}
	}
}

.line2{
	overflow: hidden;
	word-break: break-all;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}
.np-alert-dialog_content {
	word-break: break-all;
}

.bom-tip-fixed{
	background: #fff;
	width: 782px;
	position: fixed;
	top:150px;
	z-index: 100;
}

.bom-table-fixed{
	width: 779px;
	position: fixed;
	top: 247px;
	z-index: 100;
	margin-left: -1px;
}

.not-match-bom{
	width: 100%;
	padding: 40px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	box-sizing: border-box;
	.icon{
		width: 54px;
		height: 52px;
		border-radius: 50%;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		align-items: center;
		border: 2px solid #d57419;
		img{
			width: 23px;
		}
	}
	p {
		width: 460px;
		font-size: 12px;
		line-height: 24px;
		text-align: center;
	}
}

.bom-check-table {
	width: 100%;
	border: 1px solid #e6e6e6;	
	margin-bottom: 20px;
	word-break: break-word;
	td,th {
		padding: 6px;
		border-left: 1px solid #e6e6e6;
		border-bottom: 1px solid #e6e6e6;
		text-align: center;
	}
	th {
		background-color: #f9f9f9;
		line-height: 1;
		padding-top: 6px;
		padding-bottom: 6px;
		height: 32px;
		font-weight: 700;
	}
	.designator-text-ellipsis {
		// display: -webkit-box;
		// -webkit-box-orient: vertical;
		// -webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		// line-height: 22px;
	}

	td{
		&:nth-child(2){
			max-width: 300px;
		}
	}
}

.bom-check-btn{
	display: block !important;
	width: 270px;
	margin: 0 auto !important;
	margin-bottom: 10px !important;

	border-color: #D2D2D2;
	color: #333;
	background-color: #fff;

	&:hover{
		border-color: #c00;
		color: #c00;
	}
	
	&:last-child{
		margin-bottom: 0 !important;
		border-color: #c00;
		color: #fff;
		background-color: #c00;

		&:hover{
			border-color: #990C12;
			background-color: #990C12;
		}
	}
}

.btn-not-allow{
	cursor: not-allowed;
	border-color: #D2D2D2;
	color: #333;
	background-color: #fff;

	.btn-loading{
		display: inline-block !important;
	}
}

// .bom-check-btn{
// 	display: block !important;
// 	width: 250px;
// 	margin: 0 auto !important;
// 	margin-bottom: 10px !important;
// 	&:last-child{
// 		margin-bottom: 0 !important;
// 	}
// }

.icon-list{
	width: 100%;
	display: flex;
	justify-content: space-between;
	margin-top: 13px;
	margin-bottom: 31px;

	.icon-item{
		width: 120px;
		height: 120px;
		background: #fff8f8;
		border-radius: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		box-sizing: border-box;
		padding: 20px 0 15px;


		img{
			width: 40px;
			height: 40px;
		}
	}
}

.analyzing-box-bom{
	width: 100%;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	box-sizing: border-box;
	padding: 20px;
	height: 135px;
	margin-top: 20px;
	background: #f8f8f8;
}

.hide-btn{
	display: none !important;
}

@property --t { 
    syntax: '<integer>';
    inherits: false;
    initial-value: 0;
}
@counter-style stop {
    system: cyclic;
    symbols: "0";
    range: infinite 0;
}

count-down{
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Consolas, Monaco, monospace;
    font-size: 40px;
		// color: #f77878;
}
count-down::after{
    --t: 30;
    --dur: 1;
    counter-reset: time var(--t);
    content: counter(time, stop);
    animation: count calc( var(--t) * var(--dur) * 1s ) steps(var(--t)) forwards,
    // shark calc(var(--dur) * 1s) calc(var(--dur) * .8s) calc(var(--t));
}
count-down:active::after{
    animation: none;
    content: '重新开始';
}
@keyframes count {
    to {
        --t: 0;
    }
}
@keyframes shark {
    0%{
        opacity: 1;
        transform: scale(1);
    }
    
    20%{
        opacity: 0;
        transform: scale(0.4);
    }
}

.count-loading{
	width: 100px;
	height: 100px;
	position: relative;
}

.count-num{
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate3d(-50%,-50%,0);
}
</style>
